import type { ReactNode } from "react";
import { LegalLinks } from "@/components/Legal/LegalLinks";

// Mirror of legacy `(routes)/auth/layout.tsx` — outer card + circle background.
// next-intl messages are loaded by the root I18nProvider; no per-layout fetch
// needed in the SPA.
export function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <div className="relative min-h-screen surface-primary">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2">
          {/* vh on purpose, not dvh: these two numbers only set the ellipse's
              PROPORTION. With dvh the shape would resize on every mobile-Safari
              toolbar show/hide, i.e. on every scroll. Nothing is laid out
              against it, so the large-viewport unit is harmless here. */}
          <div className="w-[264vh] h-[132vh] surface-secondary rounded-[50%/50%] translate-y-1/2" />
        </div>
      </div>
      <div className="relative min-h-screen flex flex-col items-center justify-center py-8 px-4">
        {children}
        {/* Imprint + privacy on every auth page: a visitor who has no account
            yet has no other way to reach them from here. */}
        <LegalLinks className="mt-6 flex items-center gap-4" />
      </div>
    </div>
  );
}
